import { useCategories } from '@/api/generated';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Category from '@/routes/(app)/agents/components/category';

const Categories = () => {
  const { data: categories } = useCategories();

  return (
    <Tabs defaultValue={categories?.[0]?.id}>
      <TabsList>
        {categories?.map((category) => (
          <TabsTrigger
            key={category.id}
            value={category.id}>
            {category.name}
          </TabsTrigger>
        ))}
      </TabsList>
      {categories?.map((category) => (
        <TabsContent
          key={category.id}
          value={category.id}>
          <Category category={category} />
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default Categories;
